const subdomainsBlocked = [
  'expo-sexo-latino-la-capital-del-erotismo',
  'pride-day-party',
  'bonbon-the-pride-celebration-2025-250610-7878-1',
  'l,atinamericanpride2025',
  'love-of-lesbian-en-ciudad-juarez',
  'the-pride-celebration-bonbon',
  'lucha-libre-resplandor-ulc',
  'latinamericanpride2024',
  'setPreSaleBinValid,',
  'lucha-libre-ulc-por-el-honor',
  'expoespiritualidad',
  'sundrag-brunch-halloween-edition',
  'sundrag-brunch-queretaro-4ta-edicion',
  'ladomingabrunch',
  'vip-urgent-travels',
  'love-is-wooow-pride-party',
  'expo-sexo-latino-la-capital-del-erotismo-250711-7daf-1',
  'queer-as-punk',
];

export const isSubdomainBlocked = (subdomain) =>
  subdomainsBlocked.includes(subdomain);
